export enum ImportStatus {
    Success = 'Success'
}

export enum ImportedItemStatus {
    OK = 'OK',
    Error = 'Error',
    Warning = 'Warning'
}
